// Copy the wines area's screens and components added while moving to the design system (src/ui).
// One entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const winesCopy = {
  nl: {
    "wines.aroma.explain": "{descriptor} hoort bij {cluster} ({origin}).",
    "wines.aroma.select": "Kies dit aroma",
    "wines.aroma.deselect": "Haal dit aroma weg",
    "wines.journal.open": "Openen",
    "wines.journal.refresh": "Proeven verversen",
    "wines.cellar.open": "Openen",
    "wines.cellar.refresh": "Kelder verversen",
    "wines.cellar.qr": "QR-code naar deze fles",
  },
  en: {
    "wines.aroma.explain": "{descriptor} belongs to {cluster} ({origin}).",
    "wines.aroma.select": "Choose this aroma",
    "wines.aroma.deselect": "Remove this aroma",
    "wines.journal.open": "Open",
    "wines.journal.refresh": "Refresh tastings",
    "wines.cellar.open": "Open",
    "wines.cellar.refresh": "Refresh cellar",
    "wines.cellar.qr": "QR code for this bottle",
  },
  de: {
    "wines.aroma.explain": "{descriptor} gehört zu {cluster} ({origin}).",
    "wines.aroma.select": "Dieses Aroma wählen",
    "wines.aroma.deselect": "Dieses Aroma entfernen",
    "wines.journal.open": "Öffnen",
    "wines.journal.refresh": "Verkostungen aktualisieren",
    "wines.cellar.open": "Öffnen",
    "wines.cellar.refresh": "Keller aktualisieren",
    "wines.cellar.qr": "QR-Code zu dieser Flasche",
  },
  fr: {
    "wines.aroma.explain": "{descriptor} appartient à {cluster} ({origin}).",
    "wines.aroma.select": "Choisir cet arôme",
    "wines.aroma.deselect": "Retirer cet arôme",
    "wines.journal.open": "Ouvrir",
    "wines.journal.refresh": "Actualiser les dégustations",
    "wines.cellar.open": "Ouvrir",
    "wines.cellar.refresh": "Actualiser la cave",
    "wines.cellar.qr": "Code QR de cette bouteille",
  },
  es: {
    "wines.aroma.explain": "{descriptor} pertenece a {cluster} ({origin}).",
    "wines.aroma.select": "Elegir este aroma",
    "wines.aroma.deselect": "Quitar este aroma",
    "wines.journal.open": "Abrir",
    "wines.journal.refresh": "Actualizar las catas",
    "wines.cellar.open": "Abrir",
    "wines.cellar.refresh": "Actualizar la bodega",
    "wines.cellar.qr": "Código QR de esta botella",
  },
  it: {
    "wines.aroma.explain": "{descriptor} appartiene a {cluster} ({origin}).",
    "wines.aroma.select": "Scegli questo aroma",
    "wines.aroma.deselect": "Rimuovi questo aroma",
    "wines.journal.open": "Apri",
    "wines.journal.refresh": "Aggiorna le degustazioni",
    "wines.cellar.open": "Apri",
    "wines.cellar.refresh": "Aggiorna la cantina",
    "wines.cellar.qr": "Codice QR di questa bottiglia",
  },
  pt: {
    "wines.aroma.explain": "{descriptor} pertence a {cluster} ({origin}).",
    "wines.aroma.select": "Escolher este aroma",
    "wines.aroma.deselect": "Remover este aroma",
    "wines.journal.open": "Abrir",
    "wines.journal.refresh": "Atualizar as provas",
    "wines.cellar.open": "Abrir",
    "wines.cellar.refresh": "Atualizar a adega",
    "wines.cellar.qr": "Código QR desta garrafa",
  },
} as const;
